import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductSection() {
  const tomos = [{
    emoji: '📘',
    title: 'Tomo 1 — Escáner de Neuro-Inflamación',
    subtitle: '"El Mapa del Pantano Mental"',
    items: ['Test de autodiagnóstico neuro-digestivo', 'Los 7 síntomas atribuidos erróneamente a la edad', 'La conexión SIBO-fatiga-niebla mental', 'Plan de acción para los primeros 3 días'],
    color: 'border-blue-500/30'
  }, {
    emoji: '📗',
    title: 'Tomo 2 — Protocolo Flash: 24h de Claridad',
    subtitle: '"Limpieza de Emergencia"',
    items: ['Menú exacto de 24 horas para frenar la fermentación', 'Lista de compras argentina lista para usar', 'El principio del "Escudo Seco"', 'Semáforo FODMAP argentino completo'],
    color: 'border-green-500/30'
  }, {
    emoji: '📙',
    title: 'Tomo 3 — Manual del Interruptor Vagal',
    subtitle: '"El Interruptor Vagal"',
    items: ['3 ejercicios físicos y somáticos de 2 minutos', 'La Respiración del Reset', 'La Vibración Vagal', 'La Activación Somática Cervical', 'Resultados desde la primera práctica'],
    color: 'border-orange-500/30'
  }, {
    emoji: '📕',
    title: 'Tomo 4 — Guía de Supermercado Anti-Niebla',
    subtitle: '"Semáforo de Compras"',
    items: ['Cómo comprar en cualquier súper argentino sin inflamarte', 'Lista verde y roja góndola por góndola con marcas locales', 'Los 15 ingredientes ocultos que fermentan', 'Lectura de etiquetas en 30 segundos'],
    color: 'border-red-500/30'
  }, {
    emoji: '📓',
    title: 'Tomo 5 — Hoja de Ruta: Nitidez 365',
    subtitle: '"Blindaje a Largo Plazo"',
    items: ['Sistema de mantenimiento para que la nube no vuelva', 'Calendario integrado de 90 días', 'Protocolo de Reintroducción', 'La Regla del 80/20 para sostener el resultado'],
    color: 'border-gray-500/30'
  }];
  const includes = ['Plan diario listo para arrancar hoy mismo', 'Test de autodiagnóstico neuro-digestivo', 'Semáforo FODMAP adaptado a Argentina', 'Tracker de síntomas + criterios de medición', 'Errores frecuentes y cómo evitarlos', 'Checklist imprimible por etapa', '100% adaptado a la mujer argentina +55'];
  return <section className="py-24 bg-brand-dark" data-id="element-227">
      <div className="container mx-auto px-4" data-id="element-228">
        <div className="max-w-5xl mx-auto" data-id="element-229">
          <div className="text-center mb-16" data-id="element-230">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-231">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-brand-gold font-[Poppins,_sans-serif]" data-id="element-232">
                🏆 CÓDIGO NIEBLA CERO™
              </h2>
              <p className="text-2xl text-white font-medium mb-2" data-id="element-233">
                5 Tomos + 5 Bonos — 300+ páginas de implementación inmediata.
              </p>
            </motion.div>
          </div>

          <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-234">
            📚 5 TOMOS COMPLETOS
          </h3>

          <div className="grid gap-6 mb-16" data-id="element-235">
            {tomos.map((tomo, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-brand-black p-6 md:p-8 rounded-2xl border ${tomo.color} flex flex-col md:flex-row gap-6 items-start hover:bg-gray-900/50 transition-colors`} data-id="element-236">
                <div className="text-5xl shrink-0" data-id="element-237">{tomo.emoji}</div>
                <div data-id="element-238">
                  <h4 className="text-xl font-bold text-white mb-1" data-id="element-239">
                    {tomo.title}
                  </h4>
                  <p className="text-sm text-brand-light italic mb-3" data-id="element-240">
                    {tomo.subtitle}
                  </p>
                  <ul className="space-y-2" data-id="element-241">
                    {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-242">
                        <CheckCircle2 className="w-5 h-5 text-brand-light shrink-0 mt-0.5" data-id="element-243" />
                        <span data-id="element-244">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-green/10 border border-brand-green/30 rounded-2xl p-8 md:p-10" data-id="element-245">
            <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-246">
              Cada tomo incluye:
            </h4>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-247">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-248">
                  <CheckCircle2 className="w-6 h-6 text-brand-light shrink-0" data-id="element-249" />
                  <span className="text-gray-200" data-id="element-250">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}